<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDisciplineTaskConfirm } from '../../model/modal-discipline-task-confirm.hook'

defineOptions({
  name: 'ModalDisciplineTaskCancel',
})

const {
  refIsCancelOpen,
  refIsLoading,
  refCancelDetail,
  closeModal,
  cancelTask,
} = useModalDisciplineTaskConfirm()
</script>

<template>
  <ModalConfirmation
    :show="refIsCancelOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Cancel task?"
    cancel-title="Keep it"
    @click:confirm="cancelTask"
    @click:cancel="closeModal"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refCancelDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
